import { filterFields } from './filter-fields'
import AssetsTableFilter from './Filter'
import { AccordionItem } from '@components/common/Accordion/Accordion.types'
import { Accordion, Tag } from '@components/common'
import { ActiveFilterTag } from '../AssetsTable.types'

interface Props {
  fields
  activeFilterTags: ActiveFilterTag[]
  removeFilter: (field: string, isRange: boolean, isMin?: boolean, isMax?: boolean) => void
}
const Filters = ({ fields, activeFilterTags, removeFilter }: Props) => {
  const prioritizedColumns: string[] = ['AssetID', 'AS_DESC']

  function sortByLabel(a, b) {
    const textA = fields[a.column].toUpperCase()
    const textB = fields[b.column].toUpperCase()
    if (textA < textB) return -1
    if (textA > textB) return 1
    return 0
  }

  const prioritizedFilters = filterFields
    .filter(filter => prioritizedColumns.includes(filter.column))
    .sort(
      (a, b) =>
        prioritizedColumns.indexOf(a.column) - prioritizedColumns.indexOf(b.column)
    )

  const remainingFilters = filterFields
    .filter(filter => !prioritizedColumns.includes(filter.column))
    .sort(sortByLabel)

  const filterFieldsInSidesheet = [...prioritizedFilters, ...remainingFilters]

  const isFilterActive = (column: string): boolean => {
    if (activeFilterTags.filter(activeFilter => activeFilter.field === column).length > 0) {
      return true
    }

    return false
  }

  const fieldActiveFilterTag = (column: string) => {
    return activeFilterTags.find(activeFilter => activeFilter.field === column)
  }

  const accordionItems: AccordionItem[] = filterFieldsInSidesheet.map(filter => ({
    label: fields[filter.column],
    content: <AssetsTableFilter filter={filter} />,
    subHeading: isFilterActive(filter.column) ? (
      <Tag
        content={fieldActiveFilterTag(filter.column).label}
        appearance="default"
        remove={() =>
          removeFilter(
            fieldActiveFilterTag(filter.column).field,
            fieldActiveFilterTag(filter.column).isRange,
            fieldActiveFilterTag(filter.column).isMin,
            fieldActiveFilterTag(filter.column).isMax
          )
        }
      />
    ) : null,
  }))

  return (
    <div>
      <Accordion items={accordionItems} />
    </div>
  )
}
export default Filters
